import { DefaultLayout } from "components";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const layoutStyles = {
  lgColumns: "lg:grid-cols-10",
  bgColor: "bg-white"
};

const NoMatchPage = () => {
  return (
    <DefaultLayout {...layoutStyles}>
      <Helmet>
        <title>Page Not Found | SplitWise</title>
      </Helmet>
      <section className="col-span-10 overflow-y-auto bg-white">
        <section className="flex flex-col h-screen items-center justify-center">
          <section className="text-center w-full px-7 md:px-0 md:w-3/5">
            <h1 className="text-7xl md:text-9xl tracking-wider leading-snug text-gray-700 md:pb-12 font-extrabold">
              404
            </h1>
            <p className="karla text-3xl text-gray-700">Page not found</p>
            {/* TODO: add help center link */}
            <p className="karla text-sm text-gray-700 mt-5">
              Something went wrong, the requested page could not be found.
              <br /> Try going back to the previous page or see our{" "}
              <b className="text-blue-primary-faded">Help Center</b> for more information
            </p>
          </section>
          <Link to="/" className="mt-8">
            <span className="text-gray-700 karla-exl py-1 px-4 border border-gray-700 hover:bg-gray-700 hover:text-white">
              Go Back to Home
            </span>
          </Link>
        </section>
      </section>
    </DefaultLayout>
  );
};

export default NoMatchPage;
